import { ListBooking } from 'types';
import { ItemLinkProps } from '../../../Components/ItemLinks/ItemLink';
import { viewDetailsLink } from 'lib/gaTracking/bookingListPageEvents';

export const generateViewBookingDetailsItemLink = (booking: ListBooking, onTrack: () => void): ItemLinkProps => ({
  label: 'View details',
  url: booking.links.manage,
  onClick: () => {
    onTrack();
    viewDetailsLink(booking);
  },
  'data-testid': 'view-booking-details-link',
});
